export const sharedConsts = {
  iosAppLink: 'https://apps.apple.com/us/app/opsopti/id6740011204',
  androidAppLink: 'https://play.google.com/store/apps/details?id=com.opsopti.app',
}
